
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useSalesContent } from '@/components/agents/industry/content/sales';
import IndustryPage from '@/components/agents/industry/IndustryPage';
export default function SalesAgents() {
    const content = useSalesContent();
    return <IndustryPage content={content}/>;
}

    async function __Next_Translate__getStaticProps__1a12e86ee2f__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/chatbots/sales',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a12e86ee2f__ as getStaticProps }
  